function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h18v18H0z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9 6.022c-.36 0-.624-.08-.792-.24a.885.885 0 01-.24-.636v-.264c0-.256.08-.464.24-.624.168-.168.432-.252.792-.252.36 0 .62.084.78.252.168.16.252.368.252.624v.264a.862.862 0 01-.252.636c-.16.16-.42.24-.78.24zm-.888.672h1.776v6.3H8.112v-6.3z",
  fill: "#C4C4C4"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 17,
  height: 17,
  rx: 8.5,
  stroke: "#C4C4C4"
});

function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _ref, _ref2, _ref3));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8ZyBzdHlsZT0ibWl4LWJsZW5kLW1vZGU6bXVsdGlwbHkiPgogICAgPHJlY3Qgd2lkdGg9IjE4IiBoZWlnaHQ9IjE4IiBmaWxsPSJub25lIi8+CiAgICA8cGF0aCBkPSJNOC45OTk3NyA2LjAyMTk4QzguNjM5NzcgNi4wMjE5OCA4LjM3NTc3IDUuOTQxOTggOC4yMDc3NyA1Ljc4MTk4QzguMDQ3NzcgNS42MTM5OCA3Ljk2Nzc3IDUuNDAxOTggNy45Njc3NyA1LjE0NTk4VjQuODgxOThDNy45Njc3NyA0LjYyNTk4IDguMDQ3NzcgNC40MTc5OCA4LjIwNzc3IDQuMjU3OThDOC4zNzU3NyA0LjA4OTk4IDguNjM5NzcgNC4wMDU5OCA4Ljk5OTc3IDQuMDA1OThDOS4zNTk3NyA0LjAwNTk4IDkuNjE5NzcgNC4wODk5OCA5Ljc3OTc3IDQuMjU3OThDOS45NDc3NyA0LjQxNzk4IDEwLjAzMTggNC42MjU5OCAxMC4wMzE4IDQuODgxOThWNS4xNDU5OEMxMC4wMzE4IDUuNDAxOTggOS45NDc3NyA1LjYxMzk4IDkuNzc5NzcgNS43ODE5OEM5LjYxOTc3IDUuOTQxOTggOS4zNTk3NyA2LjAyMTk4IDguOTk5NzcgNi4wMjE5OFpNOC4xMTE3NyA2LjY5Mzk4SDkuODg3NzdWMTIuOTk0SDguMTExNzdWNi42OTM5OFoiIGZpbGw9IiNDNEM0QzQiLz4KICAgIDxyZWN0IHg9IjAuNSIgeT0iMC41IiB3aWR0aD0iMTciIGhlaWdodD0iMTciIHJ4PSI4LjUiIHN0cm9rZT0iI0M0QzRDNCIvPgogIDwvZz4KPC9zdmc+Cg==";
export { SvgInfo as ReactComponent };